import API from "../../lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from "../../components/ui/select";

function OrderStatusBadge({ status }) {
  if (status === "confirmed") return <span className="px-3 py-1 text-[10px] uppercase tracking-[0.15em] border border-green-500/30 text-green-400">{status}</span>;
  if (status === "shipped") return <span className="px-3 py-1 text-[10px] uppercase tracking-[0.15em] border border-blue-500/30 text-blue-400">{status}</span>;
  return <span className="px-3 py-1 text-[10px] uppercase tracking-[0.15em] border border-[#D4AF37]/30 text-[#D4AF37]">{status}</span>;
}

export default function OrdersTab({ orders, onReload }) {
  const handleOrderStatus = async (orderId, newStatus) => {
    try {
      await API.put(`/admin/orders/${orderId}`, { status: newStatus });
      onReload();
    } catch (err) {
      console.error("Failed to update order status:", err);
    }
  };

  if (orders.length === 0) {
    return <p className="text-[#A1A1AA] text-sm font-light py-8">No orders yet</p>;
  }

  return (
    <div className="space-y-3" data-testid="admin-orders-list">
      {orders.map(order => (
        <div key={order.id} className="bg-[#121212] border border-[rgba(212,175,55,0.1)] p-6" data-testid={`admin-order-${order.id}`}>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <p className="text-xs text-[#A1A1AA] font-light">#{order.id?.slice(0, 8)} | {order.user_email}</p>
              <p className="text-xs text-[#A1A1AA] font-light mt-1">{new Date(order.created_at).toLocaleDateString()}</p>
              <div className="flex flex-wrap gap-2 mt-2">
                {order.items?.map((item) => (
                  <span key={`${order.id}-${item.product_id}`} className="text-xs text-[#FDFBF7] bg-[#0a0a0a] px-2 py-1 font-light">{item.name} x{item.quantity}</span>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-4">
              <Select value={order.status} onValueChange={(val) => handleOrderStatus(order.id, val)}>
                <SelectTrigger className="w-[140px] bg-[#0a0a0a] border-white/10 text-[#FDFBF7] text-xs h-8" data-testid={`order-status-select-${order.id}`}>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-[#121212] border-white/10">
                  <SelectItem value="pending" className="text-[#FDFBF7] text-xs">Pending</SelectItem>
                  <SelectItem value="confirmed" className="text-[#FDFBF7] text-xs">Confirmed</SelectItem>
                  <SelectItem value="shipped" className="text-[#FDFBF7] text-xs">Shipped</SelectItem>
                  <SelectItem value="delivered" className="text-[#FDFBF7] text-xs">Delivered</SelectItem>
                </SelectContent>
              </Select>
              <span className="text-[#D4AF37] font-['Cormorant_Garamond'] text-lg font-light">${order.total?.toFixed(2)}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
